import type {EngagementLevel} from 'src/api/client/models/analytics'

/** Mantine color names for `Badge` and other components that take a `color` prop. */
export const ENGAGEMENT_BADGE_COLORS = {
    'Very Engaged': 'green',
    Engaged: 'engaged',
    'Somewhat Engaged': 'orange',
    'Minimally Engaged': 'rose',
    Disengaged: 'disengaged',
} as const satisfies Record<EngagementLevel, string>

/**
 * Fill colors for charts (Recharts, SVG). Uses the same palette as engagement badges,
 * resolved to Mantine theme shades so they stay aligned with the UI.
 */
export const ENGAGEMENT_CHART_COLORS: Record<EngagementLevel, string> = {
    'Very Engaged': 'var(--mantine-color-green-6)',
    Engaged: 'var(--mantine-color-engaged-6)',
    'Somewhat Engaged': 'var(--mantine-color-orange-6)',
    'Minimally Engaged': 'var(--mantine-color-rose-6)',
    Disengaged: 'var(--mantine-color-disengaged-6)',
}

/** Resolves API/string engagement labels to Mantine `Badge` colors. */
export function engagementBadgeColor(level: EngagementLevel | null): string {
    if (level == null) return 'gray'
    return ENGAGEMENT_BADGE_COLORS[level as EngagementLevel] ?? 'gray'
}
